import React,{ Component } from 'react';
import {
  Row,
  Col,
  Button
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import GregProfile from '../assets/greg-profile.png';
import GloatingCreamsicle from '../../../shared/assets/gloating-creamsicle.png';


class OnboardingHiImGreg extends Component {
  render(){
    return (
      <div className='OnboardingHiImGreg'>
        <br />
        <br />
        <Row>
          <Col xs='12' sm={{size:6,offset:3}}>
            <img 
              src={GloatingCreamsicle} 
              className='GloatingCreamsicle' 
              alt='Gloating Creamsicles'
            />
            <br />
            <br />
            <h2>Got it!  We'll review it soon.</h2>
            <hr />
            <Row>
              <Col xs={{size:2,offet:1}}>
                <img src={GregProfile} className='Greg' alt='Greg face' />
              </Col>
              <Col xs='8'>
                <p>
                  Hi I'm Greg, I'll review your experience.  Once approved, it will go live on its start date.
                </p>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs='12'>
                <Button
                  tag={Link}
                  to={`/account/experiences`}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;Go to your dashboard&nbsp;&nbsp;&nbsp;&nbsp;
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}

OnboardingHiImGreg.propTypes = {
  //TODO: Fill in prop types for OnboardingHiImMary
};

OnboardingHiImGreg.defaultProps = {
  //TODO: Fill in defaultProps for OnboardingHiImMary
};

export default OnboardingHiImGreg;



// WEBPACK FOOTER //
// ./src/routes/OnboardingHiImGreg/components/OnboardingHiImGreg.js